import React, { useState } from 'react'

import { Box, Button, Typography } from '@material-ui/core'
import { PlusCircle } from 'react-feather'

import { FragilitiesTable, FragilityModal } from './components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

import constants from 'constants/index'
import helpers from 'helpers'
import useStyles from './styles'

const FragilitiesSection = () => {
  const [openModal, setOpenModal] = useState(false)

  const {
    companySupplier,
    companySupplierId,
    isShow,
    isPreAvaliation,
    fromCreate,
    refresh,
  } = useThirdPartyManagementStepper()

  const fragilities = companySupplier?.companySupplierCompanyFragilities ?? []

  const classes = useStyles()

  const { STEPS } = constants.tours.thirdPartyManagements

  return (
    <Box
      id={helpers.thirdPartyManegementPartners.getRisksTourStepId({
        STEPS,
        isPreAvaliation,
        fromCreate,
        step: 2,
      })}
    >
      <Box className={classes.header}>
        <Typography variant="h6">Ameaças</Typography>
        {!isShow && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<PlusCircle size={18} />}
            onClick={() => setOpenModal(true)}
          >
            Adicionar ameaças
          </Button>
        )}
      </Box>

      <FragilitiesTable
        fragilities={fragilities}
        isShow={isShow}
        refresh={refresh}
      />

      {openModal && (
        <FragilityModal
          open={openModal}
          setOpen={setOpenModal}
          companySupplierId={companySupplierId}
          linkedFragilities={fragilities}
          refresh={refresh}
        />
      )}
    </Box>
  )
}

export default FragilitiesSection
